<div class="gallery-upload" *transloco="let t" data-testid="gallery-upload">
  @if (label()) {
    <label class="block text-sm font-medium text-surface-700 mb-2">
      {{ label() }}
      <span class="text-surface-500 font-normal"> ({{ totalCount() }}/{{ maxImages() }}) </span>
    </label>
  }

  @if (configLoading()) {
    <div class="flex justify-center items-center py-8">
      <p-progressSpinner strokeWidth="4" ariaLabel="loading" />
    </div>
  } @else if (configError()) {
    <div class="flex flex-col items-center gap-4 py-8">
      <p-message severity="error" [text]="configError()!" />
      <p-button
        data-testid="gallery-retry-btn"
        [label]="t('objects.wizard.gallery.retry')"
        icon="pi pi-refresh"
        severity="secondary"
        (onClick)="refreshConfig()"
      />
    </div>
  } @else if (uploadConfig()) {
    <ngx-media-upload data-testid="gallery-media-upload"
      [config]="uploadConfig()!"
      [items]="mediaFiles()"
      [autoUpload]="autoUpload()"
      [showUploadButton]="!autoUpload()"
      (itemsChange)="onItemsChange($event)"
      (uploadComplete)="onUploadComplete($event)"
      (uploadError)="onUploadError($event)"
    />
  }

  @if (failedCount() > 0) {
    <p-message
      data-testid="gallery-upload-failed"
      severity="error"
      [text]="t('objects.wizard.gallery.uploadFailed', { count: failedCount() })"
    />
  } @else if (pendingCount() > 0) {
    <p class="validation-hint" data-testid="gallery-upload-pending">
      <i class="pi pi-spin pi-spinner"></i>
      {{ t('objects.wizard.gallery.uploadPending', { count: pendingCount() }) }}
    </p>
  }

  @if (images().length < minImages()) {
    <p class="validation-hint">
      <i class="pi pi-info-circle"></i>
      {{ t('objects.wizard.gallery.minImagesHint', { min: minImages() }) }}
    </p>
  }
</div>
